import {
  Alert,
  AlertColor,
} from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import React from "react";
import {
  Button,
  Container,
  Content,
  ContentBody,
  ContentInput,
  ContentInputProfilePhoto,
  ContentInputProfilePhotoIcon,
  ContentTitle,
  Title,
} from "./styles";
import { useNavigate } from "react-router-dom";
import { UserPermissions } from "../../../App";

interface Props {
  userPermissions:UserPermissions;
}
const CreatePatients: React.FC<Props> = ({ userPermissions }) => {
  const navigate = useNavigate();

  const [name, setName] = React.useState<string>("");
  const [id, setID] = React.useState<string>("");
  const [website, setWebsite] = React.useState<string>("");
  const [description, setDescription] = React.useState<string>("");

  const [logo, setLogo] = React.useState<string>("");
  const hiddenLogoInput = React.useRef<HTMLInputElement>(null);

  const onCreateOrganization = () => {
    console.log(`Name: ${name}`);
    console.log(`id: ${id}`);
    console.log(`website: ${website}`);
    console.log(`description: ${description}`);
    console.log(`logo: ${logo}`);

    fetch("/api/v1/organization/add", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name,
        id,
        website,
        description,
        logo,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success === true) {
          console.log("Created!");
          setStatusMsg("Organization was created! Redirecting in 5 seconds...");
          setStatusSeverity("success");
          setShowStatus(true);
          setTimeout(() => {
            navigate(process.env.PUBLIC_URL + "/Organizations");
          }, 5000);
        } else {
          console.log("Not created: ", data.reason);
          if (data.reason === "Unkown Error")
            setStatusMsg(
              `Organization was not created due to an unkown error. Refresh the page and try again.`
            );
          else
            setStatusMsg(`Organization was not created: ${data.reason + ""}`);
          setStatusSeverity("error");
          setShowStatus(true);
        }
      });
  };

  const onImageChangeClick = () => {
    if (hiddenLogoInput.current) {
      hiddenLogoInput.current.click();
    }
  };
  const onHiddenLogoInputChange = (event: any) => {
    const fileUploaded = event.target.files[0];

    var reader = new FileReader();
    var baseString;
    reader.onloadend = function () {
      baseString = reader.result;
      setLogo(baseString + "");
    };
    reader.readAsDataURL(fileUploaded);
  };

  const [showStatus, setShowStatus] = React.useState(false);
  const [statusMsg, setStatusMsg] = React.useState("");
  const [statusSeverity, setStatusSeverity] =
    React.useState<AlertColor>("error");
  const handleCloseStatus = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setShowStatus(false);
  };

  return (
    <Container>
      <Title>
        Create Organization{" "}
        <Button onClick={onCreateOrganization}>Create</Button>
      </Title>

      <Content>
        <ContentTitle>
          {name} {id !== "" && `(${id})`}
        </ContentTitle>

        <ContentBody>
          <ContentInput
            label="Organization Name"
            variant="standard"
            onChange={(ev) => setName(ev.target.value)}
          />
          <br />

          <ContentInput
            label="Organization ID"
            variant="standard"
            onChange={(ev) => setID(ev.target.value)}
          />
          <br />

          <ContentInput
            label="Website"
            variant="standard"
            onChange={(ev) => setWebsite(ev.target.value)}
          />
          <br />

          <ContentInput
            label="Description"
            variant="standard"
            style={{ marginBottom: "2rem" }}
            onChange={(ev) => setDescription(ev.target.value)}
          />

          <ContentInputProfilePhoto onClick={onImageChangeClick}>
            <img src={logo} alt="Click here to upload the organization logo"/>
            <ContentInputProfilePhotoIcon />
            <input
              type="file"
              ref={hiddenLogoInput}
              onChange={onHiddenLogoInputChange}
              style={{ display: "none" }}
            />
          </ContentInputProfilePhoto>
        </ContentBody>
      </Content>
      {/*<div style={{ height: 500, width: '100%', paddingTop: "1rem" }}>

    </div>*/}
      <Snackbar
        open={showStatus}
        autoHideDuration={6000}
        onClose={handleCloseStatus}
      >
        <Alert
          onClose={handleCloseStatus}
          severity={statusSeverity}
          sx={{ width: "100%" }}
        >
          {statusMsg}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default CreatePatients;
